import React from 'react';
import { withAuth } from '../../hoc/Auth';
import { Container, Wrapper, Column } from '../../hoc/Layout';

import classes from './styles.module.css';

const Payouts = withAuth(({ token: _token }) => {
    return (
        <Wrapper>
            <Container>
                <Column width="780" className={classes.MainColumn}>
                    <span className={classes.Payouts}>Payouts Statistic</span>
                </Column>

                <Column width="350" className={classes.SideColumn}></Column>
            </Container>
        </Wrapper>
    );
});

export default Payouts;



// WEBPACK FOOTER //
// ./src/PagesOfAdministrator/Payouts/index.js